import { Component, EventEmitter, Input, Output } from '@angular/core'
import { PasswordTextFieldValidator } from '../../../validations/password-text-field-validator'

@Component({
    templateUrl: './confirm-profile-set-password.component.html',
    selector: 'ConfirmProfileSetPassword'
})
export class ConfirmProfileSetPasswordComponent {
    @Input() password: string
    @Input() passwordConfirmation: string
    @Output() onPasswordChange = new EventEmitter<string>()
    @Output() onPasswordConfirmationChange = new EventEmitter<string>()

    passwordValidator = new PasswordTextFieldValidator()
}
